<template>
    <div class="leagueRule">
        <div class="league-layout">
          <league-nav></league-nav>

          <div class="league-rule">
            <h3>本会规则</h3>
            <div class="Con-leagueRule">
                <p class="leagueRule-tit">中国技术创业协会留学人员创业园工作委员会规则</p>
                <p class="leagueRule-art" v-html="leagueRuleContent"></p>
            </div>
          </div>
        </div>
        <return-top></return-top>
    </div>
</template>

<script>
import LeagueNav from '@/components/leagueNav.vue'
import ReturnTop from '@/components/returnTop.vue'

export default {
  name: 'leagueRule',
  components: {
    LeagueNav,
    ReturnTop
  },
  data () {
    return {
      leagueRuleContent: ''
    }
  },
  computed: {

  },
  created () {
    this.getRule()
  },
  mounted () {
    document.documentElement.scrollTop = 0

    this.$parent.activeIndex = '11'
  },
  methods: {
    async getRule () {
      try {
        const res = await this.$get(this.$url.league.leagueRule)

        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.leagueRuleContent = data.regulation
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped lang="less">
.leagueRule{
  width: 100%;
  min-height: 90vh;
  font-size: 16px;
  background-color: #F5F5F5;
  margin-top: 8px;
  overflow: hidden;
}
.league-layout{
  display: flex;
  width: 1200px;
  min-height: 790px;
  margin: 0 auto;
}
.league-rule{
  width: 940px;
  min-height: 790px;
  margin: 20px auto 100px;
  background-color: #fff;
  border-radius: 2px;
  padding: 0 30px;
  overflow: hidden;
  h3{
    font-size: 20px;
    font-weight: 400;
    margin-top: 30px;
    padding-left: 15px;
    border-left: 4px solid #3056D9;
    border-radius: 2px 0 0 2px;
  }
  .Con-leagueRule{
      .leagueRule-tit{
          font-size: 22px;
          font-weight: 600;
          text-align: center;
          margin-top: 32px;
      }
      .leagueRule-art{
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          margin-top: 32px;
      }
  }
}
</style>
